import { PRStatus } from '@eapproval/offer-shared'

export const getPRStatusBadgeColor = (status) => {
  switch (status) {
    case PRStatus.SUBMITTED:
      return 'blue'
    case PRStatus.APPROVED:
      return 'green'
    case PRStatus.REJECTED:
      return 'red'
    case PRStatus.PARKED:
      return 'yellow'
    case PRStatus.DRAFT:
    default:
      return 'gray'
  }
}

const getId = (value) => value?.id || value?._id || value

export const normalizePRSubmissionForApi = (submissionDetail) => {
  const formattedSubmissionDetail = { ...submissionDetail }

  if (formattedSubmissionDetail?.raiser) {
    formattedSubmissionDetail.raiser = getId(formattedSubmissionDetail.raiser)
  }

  if (formattedSubmissionDetail?.requestor) {
    formattedSubmissionDetail.requestor = getId(formattedSubmissionDetail.requestor)
  }

  if (Array.isArray(formattedSubmissionDetail.subcontractorAgreement)) {
    formattedSubmissionDetail.subcontractorAgreement = formattedSubmissionDetail.subcontractorAgreement.map((file) =>
      getId(file)
    )
  }

  if (Array.isArray(formattedSubmissionDetail.internalDocument)) {
    formattedSubmissionDetail.internalDocument = formattedSubmissionDetail.internalDocument.map((file) => getId(file))
  }

  if (Array.isArray(formattedSubmissionDetail.requiredWorkInstructionAttachments)) {
    formattedSubmissionDetail.requiredWorkInstructionAttachments =
      formattedSubmissionDetail.requiredWorkInstructionAttachments.map((file) => getId(file))
  }

  if (Array.isArray(formattedSubmissionDetail.workInstructionFiles)) {
    formattedSubmissionDetail.workInstructionFiles = formattedSubmissionDetail.workInstructionFiles.map((file) =>
      getId(file)
    )
  }

  if (Array.isArray(formattedSubmissionDetail.approverDetails)) {
    formattedSubmissionDetail.approverDetails = formattedSubmissionDetail.approverDetails.map((approverDetail) => ({
      ...approverDetail,
      user: approverDetail?.user ? getId(approverDetail.user) : approverDetail?.user,
      attachments: Array.isArray(approverDetail?.attachments)
        ? approverDetail.attachments.map((attachment) => getId(attachment))
        : approverDetail?.attachments,
      invitedUsers: Array.isArray(approverDetail?.invitedUsers)
        ? approverDetail.invitedUsers.map((invitedUser) => ({
            ...invitedUser,
            user: invitedUser?.user ? getId(invitedUser.user) : invitedUser?.user,
            files: Array.isArray(invitedUser?.files)
              ? invitedUser.files.map((file) => getId(file))
              : invitedUser?.files,
            replyFiles: Array.isArray(invitedUser?.replyFiles)
              ? invitedUser.replyFiles.map((file) => getId(file))
              : invitedUser?.replyFiles,
          }))
        : approverDetail?.invitedUsers,
    }))
  }

  if (Array.isArray(formattedSubmissionDetail.requestedDetails)) {
    formattedSubmissionDetail.requestedDetails = formattedSubmissionDetail.requestedDetails.map((requestedDetail) => ({
      ...requestedDetail,
      detail: requestedDetail?.detail ? getId(requestedDetail.detail) : requestedDetail?.detail,
      allDetails: Array.isArray(requestedDetail?.allDetails)
        ? requestedDetail.allDetails.map((detail) => getId(detail))
        : requestedDetail?.allDetails,
    }))
  }

  return formattedSubmissionDetail
}
